import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=845f5fcc&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('845f5fcc')) {
      api.createRecord('845f5fcc', component.options)
    } else {
      api.reload('845f5fcc', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=845f5fcc&", function () {
      api.rerender('845f5fcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8435DR4Gbw8yL/JS/offershelp.vue"
export default component.exports